import style from './header.module.scss';
import Logo from '@/components/common/logo';
import UserBalance from './user-balance/user-balance';
import LanguageOption from './language-option';
import Notifications from './notifications';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import SidebarToggle from './sidebar-toggle';
import DateTime from './date-time';
import UserProfile from './user-profile';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBalanceApi } from '@/lib/features/balance/balanceSlice';
import { useEffect } from 'react';
import { clsx } from 'clsx';

const Header = () => {
    const { xlDevice, lgDevice, xsDevice, xxlDevice } = useBreakpoints();

    const dispatch = useDispatch();
    const { remoteId } = useSelector((state) => state.session);

    useEffect(() => {
        if(!remoteId) return;
        dispatch(fetchBalanceApi(remoteId));
    }, [remoteId]);

    return (
        <header className={clsx(style.header, "site_header")}>
            {!xxlDevice && (
                <div className={style.header_top}>
                    <DateTime />
                </div>
            )}
            <div className={style.header_center}>
                <div className={style.left_content}>
                    {!lgDevice && <SidebarToggle />}
                    <Logo />
                    {xxlDevice && <DateTime />}
                </div>
                <div className={style.right_content}>
                    <LanguageOption />
                    <Notifications />
                    {lgDevice && <UserBalance  />}
                    {lgDevice && <UserProfile />}
                </div>
            </div>
            <div className={style.header_bottom}>
                {!lgDevice && <UserBalance  />}
                {!lgDevice && <UserProfile />}
            </div>
        </header>
    );
};

export default Header;
